<template>
  <div>
    <Page :title="pageTitle">
      <!-- <template v-slot:action> </template> -->
      <template v-slot:default>
        <div class="flex flex-col max-w-7xl mx-auto my-10">
          <!-- <GoogleAccountConnector /> -->
          <div>
            <WidgetInstaller :widget="'google_list'" />
            <ListWidgetCustomizer />
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "../components/Common/Page";

// import GoogleAccountConnector from "../components/Widget/GoogleAccountConnector.vue";
import WidgetInstaller from "../components/Widget/WidgetInstaller.vue";
import ListWidgetCustomizer from "../components/Widget/ListWidgetCustomizer.vue";

export default {
  components: {
    Page,
    // GoogleAccountConnector
    WidgetInstaller,
    ListWidgetCustomizer
  },
  data() {
    return {
      pageTitle: "App Block"
    };
  },
  computed: {
    isGoogleConfigured() {
      const googleAccount = this.$store.getters.getGoogleAccount;
      if (googleAccount.isGoogleConnected === false) {
        return false;
      }
      if (typeof googleAccount.locationId === "undefined") {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
